import _ from "lodash";
const moment = require('moment');

// const getObjectsValue = (obj, value) => {
//   value.split(".").map(k => (obj[k] ? (obj = obj[k]) : (obj = {})));
//   return (typeof obj !== "object" || obj instanceof Array) ? obj : "";
// };


const getObjectsValue = (obj, value) => {
  // console.log(JSON.stringify(obj))
  // console.log(JSON.stringify(value))

  value.split(".").map(k => ((obj[k] || obj[k] == 0) ? (obj = obj[k]) : (obj = {})));
  return (typeof obj !== "object" || obj instanceof Array) ? obj : "";
};





// calculate age
function getMomentDiff(converted) {

  let currentage
  if (converted) {
    let diffnum = moment(converted).diff(moment(), 'milliseconds');
    let diff = moment.duration(diffnum);
    let inText = " From Now";
    if (diffnum < 0) {
      inText = " Ago";
    }
    currentage = (diff.years() != 0 ? Math.abs(diff.years()) + " Years, " : "") + (diff.months() != 0 ? Math.abs(diff.months()) + " Months, " : "") + (diff.days() != 0 ? Math.abs(diff.days()) + " Days" : "") + inText;
  } else {
    currentage = ""
  }

  return currentage;
}

const concatcols = ({ parentState, calcType, inputs, fixed }) => {
  let final = '';
  if (calcType == 'if') {
    let { src, logics, elsecond, concatby } = inputs;
    let data = fixed[src];
    if (!logics[data]) {
      final = elsecond;
    } else {
      let d = logics[data].map(dt => fixed[dt])
      final = d.join(concatby);
    }
  }
  return final;
}




// Pipeable functions.
const tableCalculations = ({ parentState, calcType, inputs }) => {
  let { field, source, filter } = inputs;
  let data = getObjectsValue(parentState, source);

  // debugger;
  let final = 0;
  if (calcType == 'sum' && data instanceof Array) {
    data.map(p => {
      // console.log(filter)
      // console.log(p.cdflag)
      let matched = true; let r1
      if (filter) {
        for (var key in filter) {
          let dat = p[key];
          if (!p[key]) { dat = false; }
          dat != filter[key] ? matched = false : r1 = 1;
        }
      }
      if (matched) {
        final += parseFloat(p[field])
      }
    });
  }
  // console.log({final})
  return final;
}

const getMultiplier = ({ mult, allResults, parentState }) => {
  let mul;
  // { source: "fixed", field: 'mult', fixed: { mult: -1 } }
  if (mult.source == 'fixed') {
    mul = mult.val;
  } else {
    let newVal;
    if (mult.source == 'allResults') {
      newVal = getObjectsValue(allResults, mult.field);
    } else if (mult.source == 'parentState') {
      newVal = getObjectsValue(parentState, mult.source);
    }
    else {
      newVal = getObjectsValue(parentState, mult.source);
    }
    mul = mult.condition[newVal] ? mult.condition[newVal] : 1;
  }
  return mul;
}

const getParentVal = ({ source, fixed, allResults, parentState, field }) => {
  let newVal;
  if (source == 'allResults') {
    newVal = getObjectsValue(allResults, field);
  } else if (source == 'row') {
    newVal = fixed[field];
  } else if (source == 'fixed') {
    newVal = field;
  }
  else {
    newVal = getObjectsValue(parentState, source);
  }
  return newVal;
}



const runFormula = ({ parentState, calcType, inputs, allResults, fixed }) => {
  return calcType(fixed);
}



const runFunction = ({ parentState, calcType, inputs, allResults, fixed }) => {
  let data = [];
  inputs.map(({ source, field, mult }, idx) => {
    let newVal = getParentVal({ source, fixed, allResults, parentState, field });
    data.push(newVal);
  });

  let final = calcType(data);

  return final;
}


const simpleArithmatic = ({ parentState, calcType, inputs, allResults, fixed }) => {
  let data = [];
  inputs.map(({ source, field, mult }, idx) => {
    let newVal = getParentVal({ source, fixed, allResults, parentState, field });
    if (mult) {
      let multval = getMultiplier({ mult, allResults, parentState });
      newVal = parseFloat(newVal) * multval;
    }
    data.push(newVal);
  });

  let final;
  if (calcType == 'sum') {
    final = 0;
    data.map(p => final += !isNaN(parseFloat(p)) ? parseFloat(p) : 0);
  }
  else if (calcType == 'multiply') {
    final = 1;
    data.map(p => final = final * p);
  }
  else if (calcType == 'pct') {
    final = (100 * data[0] / data[1]).toFixed(2);
    if (isNaN(final)) { final = 0; }
  }
  else if (calcType == 'avg') {

  } else if (calcType == 'min') {

  } else if (calcType == 'max') {

  } else if (calcType == 'mode') {

  } else if (calcType == 'median') {

  }

  // debugger;
  return final;
}


//  // { f: 'dateOperations', inputs: [{ source: 'pageData.account_opening_date', type: 'date' }, { source: 'pageData.Recurring.no_of_installment', type: 'months' }], resultVar: "maturity_date" }
const dateOperations = ({ parentState, calcType, inputs, allResults, current }) => {
  let givenDate; let givenMonth;
  let final = 0;

  inputs.map(ip => {
    let { source, type } = ip;
    let retdate = getObjectsValue(parentState, source);

    if (type == 'date') {
      final = moment(retdate);
    } else {
      final = final.add(parseInt(retdate), type);
    }
  })
  // final = moment(String(givenDate)).add(parseInt(givenMonth), 'months').format("YYYYMMDD")
  final = final.format("YYYYMMDD");
  return final;
}

const dateArithmatic = ({ parentState, calcType, inputs, allResults, current }) => {
  let final = 0;

  inputs.map(ip => {
    let { source, type } = ip;
    let retdate = getObjectsValue(parentState, source);

    if (type == 'date') {
      final = moment(retdate);
    } else {
      final = final.add(retdate, type)
    }


  })

  return moment(final).format("YYYY-MM-DD HH:mm Z")
}

const calculateAge = ({ parentState, calcType, inputs, allResults, current }) => {
  let { source, type } = inputs;
  let retdate = getObjectsValue(parentState, source);

  let agedate = getMomentDiff(retdate)


  return agedate
}
const calculateTotalPay = ({ parentState, inputs }) => {
  console.log("=========calculate Total Pay==========")
  let total_pay = 0;
  let values = []




  let conveyance = parentState.pageData.conveyance ? parseFloat(parentState.pageData.conveyance) : 0
  let da = parentState.pageData.da ? parseFloat(parentState.pageData.da) : 0
  let hra = parentState.pageData.hra ? parseFloat(parentState.pageData.hra) : 0
  let ca = parentState.pageData.ca ? parseFloat(parentState.pageData.ca) : 0
  let basic = parentState.pageData.basic ? parseFloat(parentState.pageData.basic) : 0
  let pf = parentState.pageData.pf ? parseFloat(parentState.pageData.pf) : 0
  let other = parentState.pageData.special_other ? parseFloat(parentState.pageData.special_other) : 0
  let medical = parentState.pageData.medical ? parseFloat(parentState.pageData.medical) : 0

  // let value = getObjectsValue(parentState, source);


  total_pay = conveyance + da + hra + ca + basic + pf + medical + other





  return total_pay;
}


const setParentState = ({ parentState, calcType, inputs, allResults, current }) => {
  let { dest, source, field } = inputs;
  let newVal;

  // console.log("=========Parent State=========")
  // console.log(parentState)
  if (source == 'allResults') {
    newVal = getObjectsValue(allResults, field);
  } else {
    newVal = getObjectsValue(parentState, source);
  }
  // The following MAKE the changes in the global states, because "parentState" is REFERENCED not CLONED.
  let destination = String(dest)

  if (destination.includes("#")) {

    let replacedString = destination.replace("#", ".")


    parentState.pageData[replacedString] = newVal
  }
  else {
    _.set(parentState, dest, newVal);
  }


}

const domainFunctions = {
  tableCalculations,
  simpleArithmatic,
  setParentState,
  dateOperations,
  calculateAge,
  dateArithmatic,
  concatcols,
  runFormula,
  calculateTotalPay,
  runFunction
};

// next 




export { domainFunctions };

